import { type FC, useEffect, useRef } from 'react'
import { useDebouncedCallback } from 'use-debounce'

import { Input } from '@/components/input/input'

import { cn } from '@/lib/utils'

interface Props {
  className?: string
  keyword?: string
  disabled?: boolean
  onChange?: (keyword: string) => void
}

export const CasesKeywordFilter: FC<Props> = ({ className, keyword = '', onChange }) => {
  const ref = useRef<HTMLInputElement>(null)

  const handleChange = useDebouncedCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.value)
  }, 300)

  useEffect(() => {
    if (ref.current && ref.current.value !== keyword) {
      ref.current.value = keyword
    }
  }, [keyword])

  return (
    <Input
      ref={ref}
      className={cn('h-9 w-[303px] px-3 text-sm placeholder:text-faint-foreground', className)}
      type="search"
      placeholder="Search by Type, Case Number, or Tags"
      onChange={handleChange}
    />
  )
}
